import { apiFetch } from "@utils/fetch"
import { createSignal, onMount } from "solid-js"

export interface BookkeeperProps {

}

const Bookkeeper = (_props: BookkeeperProps) => {

    const [bkStatus, setBkStatus] = createSignal<string>('No status yet.')
    const [allBooks, setAllBooks] = createSignal<any[]>([])

    const onPingBookkeeper = () => {
        apiFetch('/api/admin/bookkeeper/ping', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(resp => {
            if (!resp.ok) {
                setBkStatus(`Failed to ping Book Keeper: ${resp.statusText}`)
                return
            }
            setBkStatus('Successfully pinged Book Keeper!')
        }).catch(err => {
            setBkStatus(`Error pinging Book Keeper: ${err}`)
        })
    }

    const onListAllBooks = () => {
        apiFetch('/api/admin/bookkeeper/books', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(resp => {
            if (!resp.ok) {
                return
            }
            resp.json().then(data => {
                setAllBooks(data.logbooks)
            })
        }).catch(_err => {})
    }

    onMount(() => {
        onListAllBooks()
    })

    return (
        <div class="grow flex flex-col items-center justify-center p-6 space-y-6">
            <div class="w-full max-w-2xl space-y-6">
                <div class="bg-zinc-900 border border-zinc-800 rounded-lg p-6">
                    <h2 class="text-2xl font-semibold text-white mb-4">Book Keeper Ping</h2>
                    <div class="space-y-4">
                        <button
                            class="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded"
                            onClick={onPingBookkeeper}>Ping Book Keeper</button>
                        <p class="text-white">{bkStatus()}</p>
                    </div>
                </div>
            </div>
            <div class="w-full max-w-2xl space-y-6">
                <div class="bg-zinc-900 border border-zinc-800 rounded-lg p-6">
                    <h2 class="text-2xl font-semibold text-white mb-4">Books</h2>
                    <div class="space-y-4">
                        <table class="w-full text-left text-white">
                            <thead>
                                <tr>
                                    <th class="border-b border-zinc-700 px-4 py-2">Org Ref</th>
                                    <th class="border-b border-zinc-700 px-4 py-2">Venue Ref</th>
                                    <th class="border-b border-zinc-700 px-4 py-2">Logbook Ref</th>
                                    <th class="border-b border-zinc-700 px-4 py-2">Name</th>
                                    <th class="border-b border-zinc-700 px-4 py-2">Bookkeeper Ref</th>
                                </tr>
                            </thead>
                            <tbody>
                                {allBooks().map(book => (
                                    <tr>
                                        <td class="border-b border-zinc-700 px-4 py-2">{book.tenant_ref}</td>
                                        <td class="border-b border-zinc-700 px-4 py-2">{book.venue_ref}</td>
                                        <td class="border-b border-zinc-700 px-4 py-2">{book.logbook_ref}</td>
                                        <td class="border-b border-zinc-700 px-4 py-2">{book.name}</td>
                                        <td class="border-b border-zinc-700 px-4 py-2">{book.bookkeeper_ref}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Bookkeeper;
